import React, {useEffect, useState} from 'react';

function Error(props) {

    const [errors, setErrors] = useState([])

    useEffect(() => {
        if (props.errors.length > 0) {
            if (props.errors[0].CODE !== undefined) {
                setErrors([{
                    title: props.errors[0].CODE,
                    text: props.errors[0].TEXT,
                }])
            } else {
                switch (props.errors[0]) {
                    case 'TIME_EXPIRED':
                        setErrors([{
                            title: 'Время действия кода истекло',
                            text: 'Код больше не действителен. Запросите код повторно.',
                        }])
                        break;
                    case 'PHONE_EXISTS':
                        setErrors([{
                            title: 'Номер телефона занят',
                            text: 'К сожалению, этот номер телефона уже используется',
                        }])
                        break;
                    default:
                        setErrors([{
                            title: 'Ошибка!',
                            text: props.errors[0].replaceAll("<br>", "\\n"),
                        }])
                }
            }
        } else {
            setErrors([])
        }
    }, [props?.errors])

    if (errors.length === 0) {
        return null;
    }

    return (
        <div className="w-xs mb-3">
            <label className=" text-xs font-normal text-red-600">
                {errors[0].text}
            </label>
        </div>
    );
}

export default Error;